export default {
  textOrder: 'Are you sure you want to order this cocktail?',
  textRating: 'How you rate cocktail?',
  notWorking: 'This button is not working yet',
};
